export const NotFound = () => {
  return <div>NotFound 404</div>
}

